import { Component, Input, OnChanges } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePickerConfig } from '../../models/date-picker-config.model';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnChanges {
  @Input() config!: DatePickerConfig;

  currentErrorMessage: string | undefined;

  ngOnChanges(): void {
    this.currentErrorMessage = this.config?.errorMessage;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void {
    this.currentErrorMessage = undefined;
    if (this.config?.onValueChange && event.value) {
      this.config.onValueChange(event.value);
    }
  }

  isDateEnabled(date: Date): boolean {
    if (!this.config?.disabledDates) {
      return true;
    }

    if (Array.isArray(this.config.disabledDates)) {
      return !this.config.disabledDates.some(disabledDate =>
        date.toDateString() === disabledDate.toDateString()
      );
    }

    if (typeof this.config.disabledDates === 'function') {
      return !this.config.disabledDates(date);
    }

    return true;
  };
}